// extracted by mini-css-extract-plugin
export default {"trustedRetailerBanner":"m4-z","trustedRetailerTooltipWrapper":"n4-z"};